// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1UIYw","row":"ProcedureTreatmentSummary_row__2JadS"};